import {isYlsl} from 'Utils/ylsltools'

let tk = [
  {
    name: 'tkQuery',
    path: '/tk/tkQuery',
    component: resolve => require(['Views/Tk/tkQuery/index.vue'], resolve),
    meta: {
      include: [],
      index: 1
    }
  },
  // 康辉机票
  {
    name: 'khtkQuery',
    path: '/tk/khtkQuery',
    component: resolve => require(['Components/Dynamic/kh/views/Tk/tkQuery/index.vue'], resolve),
    meta: {
      include: [],
      index: 1
    }
  },
  {
    name: 'tkList',
    path: '/tk/tkList',
    component: resolve => require(['Views/Tk/tkQuery/tkList/index.vue'], resolve),
    meta: {
      include: ['TripAdd', 'TripRoute'],
      index: 2
    }
  },
  // 康辉模式下
  {
    name: 'khList',
    path: '/tk/khList',
    component: resolve => require(['Components/Dynamic/kh/views/Tk/tkQuery/tkList/index.vue'], resolve),
    meta: {
      include: ['TripAdd', 'TripRoute'],
      index: 2
    }
  },
  // 往返
  {
    name: 'wfList',
    path: '/tk/wfList',
    component: resolve => require(['Views/Tk/tkQuery/roundtrip/tkList/index'], resolve),
    meta: {
      include: ['TripAdd', 'TripRoute'],
      index: 2
    }
  },
  {
    name: 'tkCabin',
    path: '/tk/tkCabin',
    component: resolve => require(['Views/Tk/tkQuery/tkCabin/tkCabin.vue'], resolve),
    meta: {
      include: ['TripAdd', 'TripRoute'],
      index: 3
    }
  },
  // 康辉
  {
    name: 'khCabin',
    path: '/tk/khCabin',
    component: resolve => require(['Components/Dynamic/kh/views/Tk/tkQuery/tkCabin/tkCabin.vue'], resolve),
    meta: {
      include: ['TripAdd', 'TripRoute'],
      index: 3
    }
  },
  {
    name: 'khEdit',
    path: '/tk/khEdit',
    component: resolve => require(['Components/Dynamic/kh/views/Tk/tkQuery/tkEdit/tkEdit.vue'], resolve),
    meta: {
      include: [],
      index: 4
    }
  },
  // 区分开往返模式
  // {
  // 	name: 'wfCabin',
  // 	path: '/tk/wfCabin',
  // 	component: resolve => require(['Views/Tk/tkQuery/roundtrip/tkCabin/tkCabin'], resolve),
  // 	meta: {
  // 		include: ['TripAdd', 'TripRoute'],
  // 		index: 3
  // 	}
  // },
  {
    name: 'tkEdit',
    path: '/tk/tkEdit',
    component: resolve => require(['Views/Tk/tkQuery/tkEdit/tkEdit.vue'], resolve),
    meta: {
      include: [],
      index: 4
    }
  },
  // // 区分往返模块
  // {
  // 	name: 'tkEdit',
  // 	path: '/tk/wfEdit',
  // 	component: resolve => require(['Views/Tk/tkQuery/roundtrip/tkEdit/tkEdit'], resolve),
  // 	meta: {
  // 		include: [],
  // 		index: 4
  // 	}
  // },
  {
    name: 'tkCmp',
    path: '/tk/tkCmp',
    component: resolve => require(['Views/Tk/tkQuery/tkCmp/index.vue'], resolve),
    meta: {
      include: [],
      index: 5
    }
  },
  // 往返拆分
  // {
  // 	name: 'wfCmp',
  // 	path: '/tk/wfCmp',
  // 	component: resolve => require(['Views/Tk/tkQuery/roundtrip/tkCmp/index.vue'], resolve),
  // 	meta: {
  // 		include: [],
  // 		index: 5
  // 	}
  // },
  //订单详情
  {
    name: 'tkOrderDetail',
    path: '/tk/tkOrderDetail',
    component: resolve => require(['Views/Tk/tkOrder/detail.vue'], resolve),
    meta: {
      include: [],
    }
  },
  // 往返模块区分
  {
    name: 'wfOrderDetail',
    path: '/tk/wfOrderDetail',
    component: resolve => require(['Views/Tk/tkQuery/roundtrip/tkOrder/detail'], resolve),
    meta: {
      include: [],
    }
  },
  {
    name: 'tkOrderDetaillc',
    path: '/tk/tkOrderDetaillc',
    component: resolve => require(['Views/Tk/tkQuery/dc/tkOrder/detail'], resolve),
    meta: {
      include: [],
    }
  },
  //申请退票 正常单
  {
    name: 'tkRefundApply',
    path: '/tk/tkRefundApply',
    component: resolve => require(['Views/Tk/tkRefund/apply.vue'], resolve),
    meta: {
      include: [],
    }
  },
  //申请退票 国际正常单
  {
    name: 'tkRefundApplygj',
    path: '/tk/tkRefundApplygj',
    component: resolve => require(['Views/Tk/tkRefund/applygj.vue'], resolve),
    meta: {
      include: [],
    }
  },
  //申请退票联程 正常单
  {
    name: 'tkRefundApplylc',
    path: '/tk/tkRefundApplylc',
    component: resolve => require(['Views/Tk/tkQuery/dc/tkRefund/apply'], resolve),
    meta: {
      include: [],
    }
  },
  {
    name: 'wftkRefundApply',
    path: '/tk/wfRefundApply',
    component: resolve => require(['Views/Tk/tkQuery/roundtrip/tkRefund/apply.vue'], resolve),
    meta: {
      include: [],
    }
  },
  //退票订单详情
  {
    name: 'tkRefundDetail',
    path: '/tk/tkRefundDetail',
    component: resolve => require(['Views/Tk/tkRefund/detail.vue'], resolve),
    meta: {
      include: [],
    }
  },
  // 多程退票详情
  {
    name: 'tkRefundDetaillc',
    path: '/tk/tkRefundDetaillc',
    component: resolve => require(['Views/Tk/tkQuery/dc/tkRefund/detail.vue'], resolve),
    meta: {
      include: [],
    }
  },
  {
    name: 'wfRefundDetaillc',
    path: '/tk/wfRefundDetail',
    component: resolve => require(['Views/Tk/tkQuery/roundtrip/tkRefund/detail.vue'], resolve),
    meta: {
      include: [],
    }
  },
  //退票订单完成页面
  {
    name: 'tkRefundCmp',
    path: '/tk/tkRefundCmp',
    component: resolve => require(['Views/Tk/tkRefund/cmp.vue'], resolve),
    meta: {
      include: [],
    }
  },
  //多程退票订单完成页面
  {
    name: 'tkRefundCmplc',
    path: '/tk/tkRefundCmplc',
    component: resolve => require(['Views/Tk/tkQuery/dc/tkRefund/cmp'], resolve),
    meta: {
      include: [],
    }
  },
  //申请改签 正常单
  {
    name: 'tkChangeApply',
    path: '/tk/tkChangeApply',
    component: resolve => require(['Views/Tk/tkChange/apply.vue'], resolve),
    meta: {
      include: [],
    }
  },
  //申请改签 正常单
  {
    name: 'tkChangeApply',
    path: '/tk/tkChangeApplygj',
    component: resolve => require(['Views/Tk/tkChange/applygj.vue'], resolve),
    meta: {
      include: [],
    }
  },
  //申请改签往返
  {
    name: 'wfChangeApply',
    path: '/tk/wfChangeApply',
    component: resolve => require(['Views/Tk/tkQuery/roundtrip/tkChange/apply.vue'], resolve),
    meta: {
      include: [],
    }
  },
  // 多程
  {
    name: 'tkChangeApplylc',
    path: '/tk/tkChangeApplylc',
    component: resolve => require(['Views/Tk/tkQuery/dc/tkChange/apply.vue'], resolve),
    meta: {
      include: [],
    }
  },
  //改签订单详情
  {
    name: 'tkChangeDetail',
    path: '/tk/tkChangeDetail',
    component: resolve => require(['Views/Tk/tkChange/detail.vue'], resolve),
    meta: {
      include: [],
    }
  },
  //往返改签订单详情
  {
    name: 'wfChangeDetail',
    path: '/tk/wfChangeDetail',
    component: resolve => require(['Views/Tk/tkQuery/roundtrip/tkChange/detail'], resolve),
    meta: {
      include: [],
    }
  },
  //改签订单详情
  {
    name: 'tkChangeCmp',
    path: '/tk/tkChangeCmp',
    component: resolve => require(['Views/Tk/tkChange/cmp.vue'], resolve),
    meta: {
      include: [],
    }
  },
  // 国际票
  {
    name: 'tkIntList',
    path: '/tk/tkIntList',
    component: resolve => require(['Views/TkInt/tkIntQuery/tkIntList.vue'], resolve),
    meta: {
      include: [],
      index: 2
    }
  },
  // 联程
  {
    name: 'tkListlc',
    path: '/tk/tkListlc',
    component: resolve => require(['Views/Tk/tkQuery/dc/tkList/index'], resolve),
    meta: {
      include: ['TripAdd', 'TripRoute'],
      index: 2
    }
  },
  //联程返回
  {
    name: 'tkCabin',
    path: '/tk/tkCabinlc',
    component: resolve => require(['Views/Tk/tkQuery/dc/tkCabin/tkCabin'], resolve),
    meta: {
      include: [],
      index: 2
    }
  },
  //联程提交订单模块
  {
    name: 'tkEditlc',
    path: '/tk/tkEditlc',
    component: resolve => require(['Views/Tk/tkQuery/dc/tkEdit/tkEdit'], resolve),
    meta: {
      include: [],
      index: 2
    }
  },
  // 测试联程待支付
  {
    name: 'tkCmp',
    path: '/tk/tkCmplc',
    component: resolve => require(['Views/Tk/tkQuery/dc/tkCmp/index'], resolve),
    meta: {
      include: [],
      index: 2
    }
  },
  // 国际票 舱位列表
  {
    name: 'tkIntCabin',
    path: '/tk/tkIntCabin',
    component: resolve => require(['Views/TkInt/tkIntQuery/tkIntCabin/index.vue'], resolve),
    meta: {
      include: [],
      index: 2
    }
  },
  // 国际票 舱位列表
  {
    name: 'tkIntEdit',
    path: '/tk/tkIntEdit',
    component: resolve => require(['Views/TkInt/tkIntQuery/tkIntEdit/index.vue'], resolve),
    meta: {
      include: [],
      index: 2
    }
  },
  // 国际票 完成
  {
    name: 'tkIntCmp',
    path: '/tk/tkIntCmp',
    component: resolve => require(['Views/TkInt/tkIntQuery/tkIntCmp/index.vue'], resolve),
    meta: {
      include: [],
      index: 2
    }
  },
  //需求单订单详情
  {
    name: 'tkNeedDetail',
    path: '/tk/tkNeedDetail',
    component: resolve => require(['Views/Tk/tkOrder/needDetail.vue'], resolve),
    meta: {
      include: [],
      index: 2
    }
  },
  // 机场攻略
  {
    name: 'tkStrategy',
    path: '/tk/strategy',
    component: resolve => require(['Views/Tk/tkStrategy/index.vue'], resolve),
    meta: {
      include: [],
      index: 2
    }
  },
  // 国内政策优惠
  {
    name: 'tkPolicy',
    path: '/tk/policy',
    component: resolve => require(['Views/Other/TkPolicy.vue'], resolve),
    meta: {
      include: [],
      index: 2
    }
  },
  // 国际特价优惠
  {
    name: 'tkIntelPolicy',
    path: '/tkIntel/policy',
    component: resolve => require(['Views/Other/TkIntelPolicy.vue'], resolve),
    meta: {
      include: ['TkIntelPolicy', 'TkIntelPolicyDetail'],
      index: 1
    }
  },
  {
    name: 'policyDetail',
    path: '/tkIntel/policy/detail/:id',
    props: true,
    component: resolve => require(['Views/Other/TkIntelPolicyDetail.vue'], resolve),
    meta: {
      include: ['TkIntelPolicy'],
      index: 2
    }
  },
  // 机场大巴
  {
    name: 'airportBus',
    path: '/tk/airportBus',
    component: resolve => require(['Views/Other/AirportBus.vue'], resolve),
    meta: {
      index: 1
    }
  },
]
if (isYlsl()) {
  tk.shift()
}
export default tk
